<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户ID ｛user.id｝" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID ｛user.id｝" />
      </a-form-model-item>
      <a-form-model-item label="银行ID｛extra_bank.id｝" prop="bankId" >
        <a-input v-model="form.bankId" placeholder="请输入银行ID｛extra_bank.id｝" />
      </a-form-model-item>
      <a-form-model-item label="银行卡号" prop="bankNo" >
        <a-input v-model="form.bankNo" placeholder="请输入银行卡号" />
      </a-form-model-item>
      <a-form-model-item label="开户行" prop="openingBank" >
        <a-input v-model="form.openingBank" placeholder="请输入开户行" />
      </a-form-model-item>
      <a-form-model-item label="预留手机号" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="请输入预留手机号" />
      </a-form-model-item>
      <a-form-model-item label="是否默认 0-否 1-是" prop="isDefault" >
        <a-input v-model="form.isDefault" placeholder="请输入是否默认 0-否 1-是" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBank, addBank, updateBank } from '@/api/user/bank'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        bankId: null,

        bankNo: null,

        openingBank: null,

        mobile: null,

        isDefault: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID ｛user.id｝不能为空', trigger: 'blur' }
        ],
        bankId: [
          { required: true, message: '银行ID｛extra_bank.id｝不能为空', trigger: 'blur' }
        ],
        bankNo: [
          { required: true, message: '银行卡号不能为空', trigger: 'blur' }
        ],
        openingBank: [
          { required: true, message: '开户行不能为空', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '预留手机号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        bankId: null,
        bankNo: null,
        openingBank: null,
        mobile: null,
        isDefault: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBank({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBank(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBank(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
